import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';
import {
  ENGLISH_LOCALE,
  JAPANESE_LOCALE,
  CHINESE_LOCALE,
  TRADITIONAL_CHINESE_LOCALE,
  KOREAN_LOCALE
} from '@link/share/constants';
import { DEFAULT_LOCALE } from '@link/share/i18n';
import enText from '@link/share/i18n/lang/en';
import jaText from '@link/share/i18n/lang/ja';
import koText from '@link/share/i18n/lang/ko';
import zhText from '@link/share/i18n/lang/zh';
import ztText from '@link/share/i18n/lang/zt';
import enAuthText from './lang/en';
import jaAuthText from './lang/ja';
import koAuthText from './lang/ko';
import zhAuthText from './lang/zh';
import ztAuthText from './lang/zt';

export const FIREBASE_LANG_MAPPING: Record<string, string> = {
  en: ENGLISH_LOCALE,
  ja: JAPANESE_LOCALE,
  ko: KOREAN_LOCALE,
  'zh-CN': CHINESE_LOCALE,
  'zh-TW': TRADITIONAL_CHINESE_LOCALE
};

const FIREBASE_LOCALES = Object.keys(FIREBASE_LANG_MAPPING);

declare module 'i18next' {
  interface CustomTypeOptions {
    returnNull: false;
  }
}

export const resources = {
  en: {
    translation: {
      ...enText,
      ...enAuthText
    }
  },
  ja: {
    translation: {
      ...jaText,
      ...jaAuthText
    }
  },
  ko: {
    translation: {
      ...koText,
      ...koAuthText
    }
  },
  zh: {
    translation: {
      ...zhText,
      ...zhAuthText
    }
  },
  zt: {
    translation: {
      ...ztText,
      ...ztAuthText
    }
  }
} as const;

void i18n.use(initReactI18next).init({
  lng: DEFAULT_LOCALE,
  returnNull: false,
  resources
});

export function setLocale(locale: string): string {
  void i18n.changeLanguage(locale);
  document.documentElement.setAttribute('lang', locale);
  localStorage.setItem('locale', locale);
  return locale;
}

function getLocaleParams() {
  const searchParams = new URLSearchParams(location.search);
  const lang = searchParams.get('lang') || '';
  if (FIREBASE_LOCALES.includes(lang)) {
    return FIREBASE_LANG_MAPPING[lang];
  }
}

(() => {
  const defaultLocale = getLocaleParams() || DEFAULT_LOCALE;
  setLocale(defaultLocale);
})();

export default i18n;
